var sliderThumbs;
var sliderImages;

$(document).ready(function() {

    /* Scroll Spy ------------------------------- */
    
    if ($('.product-nav').length) {

        if ($('#judgeme_product_reviews').length) {
            $('#judgeme_product_reviews').attr('data-scrollspy', 'Reviews');
        }

        let uniqueValues = [...new Set($('[data-scrollspy]').map(function() {
            return $(this).data('scrollspy');
        }).get())];
    
        let htmlContent = uniqueValues.map(function(value) {
            return `<a href="javascript:void(0)" data-anchor="${value}">${value}</a>`;
        }).join('');
    
        $('.product-nav .nav').html(htmlContent);
    }

    if ($('.product').length) {

        let headerHeight = $('.header-group').outerHeight();
        if ($('.header-group').css('transform') !== 'none') {
            let values = $('.header-group').css('transform').split('(')[1].split(')')[0].split(',');
            let translateY = values[5].trim();
            headerHeight = parseFloat(headerHeight) + parseFloat(translateY);
        }

        let abHeight = $('.announcement-bar').outerHeight();

        $('.product .sticky-top').css('top', `${headerHeight + 30}px`);

        if (wSize >= 1280) {
            $('.thumbnail-slider.mobile').remove();
        }
        else {
            $('.thumbnail-slider.desktop').remove();
        }

        sliderThumbs = new Swiper(".thumbnail-slider", {
            direction: "vertical",
            slidesPerView: 7,
            spaceBetween: 10,
            speed: 5000,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    direction: "horizontal"
                },
                1280: {
                    direction: "vertical"
                }
            }
        });

        sliderImages = new Swiper(".main-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            mousewheel: false,
            grabCursor: true,
            thumbs: {
                swiper: sliderThumbs
            }
        });
    }

    if ($('.content-slider').length) {
        $('.content-slider .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 20,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 2,
                        margin: 30,
                        stagePadding: 20
                    },
                    1250: {
                        items: 3,
                        margin: 30,
                        stagePadding: 20
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.brand-reviews').length) {
        $('.brand-reviews .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
            let items = $carousel.data('items');

            $carousel.owlCarousel({
                items: items,
                nav: false,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                autoHeight: true,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20
                    },
                    768: {
                        items: 2,
                        margin: 30
                    },
                    1250: {
                        items: items,
                        margin: 30
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(this).trigger('refresh.owl.carousel');
        });
    }

    let pci = $('.product-comparison .item.heading').height();
    $('.product-comparison .spec-title').height(pci);

    if ($('.scrolled-gallery').length) {
        $(window).on('scroll', function() {
            $('.scrolled-gallery').each(function() {
                let el = $(this);
                let desktop = el.find('.desktop');
                let mobile = el.find('.mobile');

                let percent = Math.max(0, Math.min(100, scrolledPercent(el)));

                const desktop_distance = 20;

                let desktop_row_1 = (percent / 100) * -desktop_distance;
                let desktop_row_2 = (percent / 100) * desktop_distance - 40;
                let desktop_row_3 = (percent / 100) * -desktop_distance - 5;

                const mobile_distance = 60;

                let mobile_row_1 = (percent / 100) * -mobile_distance - 40;
                let mobile_row_2 = (percent / 100) * mobile_distance - 30;
                let mobile_row_3 = (percent / 100) * -mobile_distance - 50;

                desktop.find('.images:nth-child(1)').css('transform', `translateX(${desktop_row_1}vw)`);
                desktop.find('.images:nth-child(2)').css('transform', `translateX(${desktop_row_2}vw)`);
                desktop.find('.images:nth-child(3)').css('transform', `translateX(${desktop_row_3}vw)`);

                mobile.find('.images:nth-child(1)').css('transform', `translateY(${mobile_row_1}vw)`);
                mobile.find('.images:nth-child(2)').css('transform', `translateY(${mobile_row_2}vw)`);
                mobile.find('.images:nth-child(3)').css('transform', `translateY(${mobile_row_3}vw)`);
            });
        });
    }

    if ($('.video-products').length) {
        $('.video-products .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 5,
                nav: true,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                onTranslate: function() {
                    $carousel.find('video').each(function () {
                        this.pause();
                        this.muted = true;
                    });
                    $carousel.find('.toggle-video').removeClass('unmute');
                },
                onTranslated: function() {
                    let video = $carousel.find('.owl-item.active').first().find('video').get(0);
                    if (video)
                        video.play();
                },
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 30
                    },
                    768: {
                        items: 2,
                        stagePadding: 30
                    },
                    1250: {
                        items: 5,
                        stagePadding: 0
                    }
                }
            });

            let video = $carousel.find('.owl-item.active').first().find('video').get(0);
            if (video)
                video.play();

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.blog-posts').length) {
        $('.blog-posts .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 4,
                nav: true,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30,
                    },
                    768: {
                        items: 2,
                        margin: 30,
                        stagePadding: 50
                    },
                    1250: {
                        items: 4,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            });

            let maxHeight = 0;
            $carousel.find('.article-title').each(function() {
                let height = $(this).outerHeight();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            $carousel.find('.article-title').css('height', maxHeight + 'px');

            $(window).resize(function() {
                let maxHeight = 0;
                $carousel.find('.article-title').each(function() {
                    let height = $(this).outerHeight();
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });
                $carousel.find('.article-title').css('height', maxHeight + 'px');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.count-effect').length) {
        $('.count-effect .count-it').each(function () {
            let $countElement = $(this);
            let rawText = $countElement.text().trim();

            let match = rawText.match(/([^0-9]*)([0-9,]+)([^0-9]*)/);

            if (!match) return;

            let prefix = match[1];
            let numberPart = match[2];
            let suffix = match[3];

            let hasComma = numberPart.includes(',');

            let originalNumber = parseInt(numberPart.replace(/,/g, ''));

            function random(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }

            let digitCount = originalNumber.toString().length;

            let random1 = random(digitCount);
            let random2 = random(digitCount);
            let random3 = random(digitCount);

            function formatNumber(num) {
                return hasComma ? num.toLocaleString() : String(num);
            }

            function build(num) {
                return `${prefix}${formatNumber(num)}${suffix}`;
            }

            $countElement.html(`
                <span>${build(random1)}</span>
                <span>${build(random2)}</span>
                <span>${build(random3)}</span>
                <span>${build(originalNumber)}</span>
            `);
        });
    }

    if ($('.product-reviews').length) {
        $('.product-reviews .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 4,
                nav: true,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        dots: true,
                    },
                    768: {
                        items: 2,
                        nav: false,
                        dots: true,
                    },
                    1250: {
                        items: 3,
                        nav: true,
                        dots: false,
                    },
                    1536: {
                        items: 4,
                        nav: true,
                        dots: false,
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
            
            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.buy-now').length) {
        let el = $('.buy-now');

        if (visiblePercent($('.product .product-form')) >= 100)
            el.addClass('show');
        else
            el.removeClass('show');

        $(window).scroll(function() {
            if (visiblePercent($('.product')) >= 100)
                el.addClass('show');
            else
                el.removeClass('show');

            console.log(visiblePercent($('.product')));
        });
        
        $('.buy-now button').on('click', function() {
            $('.product button[type="submit"]').trigger('click');
        });
    }

    if ($('.slider-content').length) {
        $('.slider-content .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: true,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                margin: 50,
                responsive: {
                    0: {
                        nav: false
                    },
                    1250: {
                        nav: true
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(window).resize(function() {
                if (wSize >= 1250)
                    $floatNav.show();
                else
                    $floatNav.hide();
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    count_effect();

    scrollSpy();

});

$(window).scroll(function() {
    count_effect();
});

$(window).resize(function() {
    if ($('.product').length) {
        let headerHeight = $('.header-group').outerHeight();
        if ($('.header-group').css('transform') !== 'none') {
            let values = $('.header-group').css('transform').split('(')[1].split(')')[0].split(',');
            let translateY = values[5].trim();
            headerHeight = parseFloat(headerHeight) + parseFloat(translateY);
        }

        let abHeight = $('.announcement-bar').outerHeight();

        $('.product .sticky-top').css('top', `${headerHeight + 30}px`);
    }
});

$(document).on('click', '.nav a[data-anchor]', function() {
    let anchor = $(this).data('anchor');
    let targetSection = $(`[data-scrollspy="${anchor}"]`);

    let headerHeight = $('.header-group').outerHeight();
    if ($('.header-group').css('transform') !== 'none') {
        let values = $('.header-group').css('transform').split('(')[1].split(')')[0].split(',');
        let translateY = values[5].trim();
        headerHeight = parseFloat(headerHeight) + parseFloat(translateY);
    }
    
    if (targetSection.length) {
        $('html, body').animate({
            scrollTop: targetSection.offset().top - headerHeight / 2
        }, 0);
    }
});

$(window).scroll(function() {
    scrollSpy();
});

function scrollSpy() {
    if ($('.product-nav').length) {
        const sections = $('[data-scrollspy]');
        let currentSection = '';

        sections.each(function () {
            const sectionTop = $(this).offset().top - 500;
            const sectionHeight = $(this).height();
            if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                currentSection = $(this).data('scrollspy');
            }
        });

        const links = $('.product-nav .nav a');
        links.removeClass('active');
        links.filter('[data-anchor="' + currentSection + '"]').addClass('active');
    }
}

$('.product-image img').on('click', function () {
    let link = $(this).parents('.product-card').find('a').attr('href');;
    if (link) {
        window.location.href = link;
    }
});

$('.tabs .tab').on('click', function() {
    let el = $(this).parents('.tabs');
    
    let idx = $(this).data('tab');

    $(this).addClass('active').siblings().removeClass('active');

    el.find(`.menu-tab[data-tab="${idx}"]`).addClass('active').siblings().removeClass('active');
});

$('.fbt select').on('change', function() {
    let id = $(this).parents('.check').data('check');

    let v_id = $(this).find('option:selected').data('v-id');
    let v_image = $(this).find('option:selected').data('v-image');
    let v_price = $(this).find('option:selected').data('v-price');
    let v_compare = $(this).find('option:selected').data('v-compare');

    // change form id
    $(`.fbt-form input[data-id="${id}"]`).val(v_id);

    // change image
    $(`.fbt .image[data-image="${id}"]`).html(`<img src="${v_image}">`);

    // change price
    $(this).next('.check-price').find('.price').html(v_price);
    $(this).next('.check-price').find('.compare').html(v_compare);

    // re-calculate total price
    let total_price = 0;
    $('.fbt .check-price .price').each(function() {
        let priceText = $(this).text().trim();
        let priceValue = parseFloat(priceText.replace(/[$,]/g, ''));

        total_price += priceValue;
    });

    let total_compare = 0;
    $('.fbt .check-price .compare').each(function() {
        let priceText = $(this).text().trim();

        if (priceText !== '') {
            let priceValue = parseFloat(priceText.replace(/[$,]/g, ''));
            if (!isNaN(priceValue)) {
                total_compare += priceValue;
            }
        }
    });

    $('.fbt-total-price').html('$'+total_price.toLocaleString());
    $('.fbt-total-compare').html('$'+total_compare.toLocaleString());

});

$('.fbt .form-check-input').on('change', function() {
    let id = $(this).parents('.check').data('check');
    
    let price = parseFloat($(this).data('price').toString().replace(/[$,]/g, '')) || 0;
    let compare = parseFloat($(this).data('compare').toString().replace(/[$,]/g, '')) || 0;

    let fbt_price = parseFloat($('.fbt-total-price').text().replace(/[$,]/g, '')) || 0;
    let fbt_compare = parseFloat($('.fbt-total-compare').text().replace(/[$,]/g, '')) || 0;

    if ($(this).is(':checked')) {
        // checked
        $(`.fbt [data-plus="${id}"]`).show();
        $(`.fbt [data-image="${id}"]`).show();

        $(`.fbt-form input[data-id="${id}"]`).attr('name', 'id[]');

        $(this).parents('.check').find('select').attr('disabled', false);

        fbt_price += price;
        if (compare > 0) fbt_compare += compare;
    } 
    else {
        // unchecked
        $(`.fbt [data-plus="${id}"]`).hide();
        $(`.fbt [data-image="${id}"]`).hide();

        $(`.fbt-form input[data-id="${id}"]`).attr('name', 'none-id[]');

        $(this).parents('.check').find('select').attr('disabled', true);

        fbt_price -= price;
        if (compare > 0) fbt_compare -= compare;
    }

    $('.fbt-total-price').text('$' + fbt_price.toLocaleString());
    $('.fbt-total-compare').text('$' + fbt_compare.toLocaleString());
});

$('.product .discount-copy').on('click', function() {
    let el = $(this).parents('.discount');

    var textToCopy = el.find('.discount-code span:first-child').text().trim();
    navigator.clipboard.writeText(textToCopy)
        .then(function() {
            el.addClass('copy');
            setTimeout(() => {
                el.removeClass('copy');
            }, 1000);
        })
        .catch(err => console.error('Failed to copy text: ', err));
});

$('.product .accessory select').on('change', function() {
    let curSy = $('.product .bundle-price').data('currency');
    let id = $(this).parents('.accessory').data('accessory');

    let v_id = $(this).find('option:selected').data('v-id');
    let v_image = $(this).find('option:selected').data('v-image');
    let v_price = $(this).find('option:selected').data('v-price');
    let v_compare = $(this).find('option:selected').data('v-compare');

    // change image
    $(this).parents('.accessory').find('.image').html(`<img src="${v_image}">`);

    // change price
    $(this).parents('.accessory').find('.price').html(curSy+v_price);
    if (v_compare)
        $(this).parents('.accessory').find('.compare').html(curSy+v_compare);
});

$('.product .accessory .add').on('click', function() {
    let id = $(this).parents('.accessory').data('accessory');

    let val = $(this).parents('.accessory').find('.data-hidden').data('v-val');
    let title = $(this).parents('.accessory').find('.accessory-title').text();
    
    let v_image = $(this).parents('.accessory').find('.data-hidden').data('v-image');
    let v_title = (t => t ? '| ' + t : '')($(this).parents('.accessory').find('.data-hidden').text().trim());
    let v_price = $(this).parents('.accessory').find('.data-hidden').data('v-price');
    let v_compare = $(this).parents('.accessory').find('.data-hidden').data('v-compare');


    if ($(this).parents('.accessory').find('select').length) {
        val = $(this).parents('.accessory').find('select').val();
        v_image = $(this).parents('.accessory').find('option:selected').data('v-image');
        v_title = (t => t ? '| ' + t : '')($(this).parents('.accessory').find('option:selected').text().trim());
        v_price = $(this).parents('.accessory').find('option:selected').data('v-price');
        v_compare = $(this).parents('.accessory').find('option:selected').data('v-compare');
    }

    $(this).parents('.accessory').toggleClass('active');
    
    if ($(this).parents('.accessory').hasClass('active')) {
        $(this).html('Remove');

        $(this).parents('.accessory').find('select').attr('disabled', true);

        // add to form
        $('.product product-form form').append(`
            <input type="hidden" name="id[]" value="${val}" id="${id}">
        `);

        // add to bundle
        $('.product .bundle .add-bundle').append(`
            <div class="product-bundle" data-bundle="${id}" data-price="${v_price}" data-compare="${v_compare}">
                <div class="image">
                    <img src="${v_image}">
                </div>
                <div class="info">
                    <p class="body-sm mt-semibold f-black">
                        ${title} ${v_title}
                    </p>
                    <span class="body-xs mt-medium f-black bundle-qty">
                        x${$('.product quantity-input input').val()}
                    </span>
                </div>
            </div>
        `);
    }
    else {
        $(this).html('Add');

        $(this).parents('.accessory').find('select').attr('disabled', false);

        // remove to form
        $('.product product-form form').find(`#${id}`).remove();

        // remove to bundle
        $(`.product .bundle .product-bundle[data-bundle="${id}"]`).remove();
    }

    totalBundle();
});

function totalBundle() {
    let curSy = $('.product .bundle-price').data('currency');
    let qty = $('.product quantity-input .quantity__input').val();

    $('.product .bundle').each(function() {
        let totalPrice = 0;
        let totalCompare = 0;

        $(this).find('.product-bundle').each(function() {
            let $product = $(this);

            let price = parseFloat($product.attr('data-price')) || 0;
            let compare = parseFloat($product.attr('data-compare')) || 0;

            totalPrice += price * qty;
            totalCompare += (compare === 0 ? price : compare) * qty;
        });

        $('.product .bundle-price .price')
            .html(curSy + totalPrice.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));

        $('.product .bundle-price .compare')
            .html(curSy + totalCompare.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
    });
}

$('.video-products .video').on('click', function() {
    let $this = $(this).find('.toggle-video');
    let video = $this.parent().find('video')[0]; // current video
    let allVideos = $this.parents('.video-products').find('video');

    allVideos.each(function() {
        if (this !== video) {
            this.pause();
            this.muted = true;
            $(this).siblings('.toggle-video').removeClass('unmute');
        }
    });

    $this.toggleClass('unmute');
    if ($this.hasClass('unmute')) {
        if (video) {
            video.play();
            video.muted = false;
        }
    } else {
        if (video) video.muted = true;
    }
});

function count_effect() {
    if ($('.count-effect').length) {
        $('.count-effect').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 50) {
                let $items = el.find('.show-up');
                let index = 0;

                let $items2 = el.find('.aos-init');
                let index2 = 0;

                let interval = setInterval(function() {
                    if (index < $items.length) {
                        $items.eq(index).addClass('show');
                        index++;
                    } else {
                        clearInterval(interval);

                        let interval2 = setInterval(function() {
                            if (index2 < $items2.length) {
                                $items2.eq(index2).addClass('aos-animate');
                                index2++;
                            } else {
                                clearInterval(interval2);
                                el.find('.count-it span').addClass('active');
                            }
                        }, 50);

                    }
                }, 100);
            }
        });    
    }
}